import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NbPopoverDirective } from '@nebular/theme';
import { OfbizForm, OfbizFormsService, handleClick, LookupFieldService } from '@urbannex/ofbiz-forms';
import { UbsComponentStoreService } from '../ubs-component-store.service';
import { ComponentConfig, ComponentState } from '../shared/model';
import { FormBuilder, FormControl } from '@angular/forms';
import { Observable } from 'rxjs';

@Component({
  selector: 'ubs-component-header-search',
  templateUrl: './component-header-search.component.html',
  styleUrls: ['./component-header-search.component.scss']
})
export class ComponentHeaderSearchComponent implements OnInit {
  @Input()
  //get state():Observable<ComponentState> 
  set state$(state$:Observable<ComponentState>){
    if(state$){
      state$.subscribe(componentState =>{
        this.state = componentState;
        this.componentConfig = this.state.componentConfig;
        this.findForm = this.componentConfig.findForm;
        this.title = componentState.componentConfig.title;
      })
    }
  }//state$:any;
  state:ComponentState;
  componentConfig:ComponentConfig;
  //state:any;
  searchOptions = false;
  filterOptions = true;
  findForm:OfbizForm;
  title:string;

  findOneForm = this.fb.group({});

  readonly results$ = this.lookupFieldService.result;

  @ViewChild('search', {static:false}) search: ElementRef;
  @ViewChild(NbPopoverDirective) templateRef: NbPopoverDirective;
  @Output() seachResults = new EventEmitter<any>();
  @Output() selectedValue = new EventEmitter<any>();
  @Output() searchExpanded = new EventEmitter<any>();
  constructor(
    private ofbizFormService:OfbizFormsService,
    private lookupFieldService:LookupFieldService,
    private fb:FormBuilder
    ) { }

  ngOnInit(): void {
    //console.log(this.componentConfig);
    //this.findForm = this.componentConfig.findForm;
    /* this.state.subscribe(data => {
      this.state = data;
      this.title = this.state.title;
    }) */
  }

  toggleFilter(){
    //console.log("toggling the filter");
    this.filterOptions != this.filterOptions;
    console.log(this.filterOptions);
  }

  toggleSearchButton(){
    this.searchOptions = !this.searchOptions;
    this.searchExpanded.emit(); 
  }

  onSearch(query){
    console.log(query);
  }

  onFocusEvent(e){
    if(this.templateRef.isShown){
      this.templateRef.hide();
    }
    if(e.value){
      //this.toggleFilter();
    }
    
  }

  lookUp(query){
    if(query !== ""){
      console.log({endPoint:this.componentConfig.lookUpEndPoint});
      this.filterOptions = false;
      this.lookupFieldService.lookUp(query,null,this.componentConfig.lookUpEndPoint,this.findForm.entityName,null)
    }
  }

  selectLookUp(e){
    console.log(e);
    console.log(e.target);
    console.log(e.target.tagName);
    let elem = handleClick(e.target);
    if(elem.tagName == "NB-OPTION"){
      this.searchOptions = false;
      console.log(this.componentConfig);
      console.log({description:elem.dataset.description,value:elem.dataset.value});
      let idField = this.componentConfig.idFieldName;
      /* let thisSelectedValue = {};
      thisSelectedValue["entityName"] = this.state.componentConfig.findForm.entityName;
      thisSelectedValue[idField] = elem.dataset.value; */
      
      //this.componentStore.updateSelectedValue(selectedValue);
      this.findOneForm.addControl("entityName",new FormControl(this.componentConfig.findForm.entityName));
      this.findOneForm.addControl(idField,new FormControl(elem.dataset.value));
      this.ofbizFormService.getOne(this.findOneForm.value)
      .subscribe(data => {
        if(data.responseMessage == "success"){
          this.selectedValue.emit(data["entity"]);
        }else{
          console.log("there's a problem")
        }
      })
    }
  }

  filterOptionsActions(){
    if(this.filterOptions){
      console.log("showFindForm")
      this.templateRef.show();
    }else{
      this.search.nativeElement.value = '';
      this.filterOptions = true;
    }
  }

  closePopover(){
    this.templateRef.hide();
    this.searchOptions = !this.searchOptions 
  }

  getSearchResults(data){
    this.seachResults.emit(data);
    /* console.log(data);
    this.componentConfig.searchResults = data;
    this.cmsStore.updateComponentConfig(this.componentConfig); */
  }


}
